var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _c(
    "v-container",
    [
      _c(
        "v-row",
        [
          _c(
            "v-col",
            { attrs: { cols: "12" } },
            [
              _c(
                "span",
                [_vm._v("Заголовок * ("), _c("TranslationIcon"), _vm._v(")")],
                1
              ),
              _c("v-text-field", {
                attrs: {
                  outlined: "",
                  disabled: _vm.isLoading,
                  loading: _vm.isLoading,
                  value: _vm.listItem.data.title,
                  "error-messages": _vm.errorMessages.title,
                },
                on: {
                  input: function ($event) {
                    return _vm.mixChangeListItemHandler($event, "title")
                  },
                },
              }),
            ],
            1
          ),
        ],
        1
      ),
      _c(
        "v-row",
        [
          _c("QuillEditorVue", {
            attrs: {
              cols: 12,
              content: _vm.listItem.data.description,
              loading: _vm.isLoading,
              disabled: _vm.isLoading,
              lightMode: true,
            },
            on: {
              input: function ($event) {
                return _vm.mixChangeListItemHandler($event, "description")
              },
              onChangeContent: function ($event) {
                return _vm.$emit("change:descriptionForMobile", $event)
              },
            },
          }),
        ],
        1
      ),
      _c(
        "v-row",
        [
          _c(
            "v-col",
            { attrs: { cols: "6" } },
            [
              _c("span", [_vm._v("Место проведения *")]),
              _c("LocationAutocomplete", {
                attrs: {
                  address: _vm.listItem.data.location,
                  loading: _vm.isLoading,
                  "error-messages": _vm.returnAddressError,
                },
                on: {
                  "set-location": function ($event) {
                    return _vm.mixChangeListItemHandler($event, "location")
                  },
                  "update-location-part": function ($event) {
                    return _vm.mixChangeListItemHandler(
                      $event.value,
                      `location.${$event.fieldName}`
                    )
                  },
                },
              }),
            ],
            1
          ),
        ],
        1
      ),
      _c(
        "v-col",
        { attrs: { cols: "12" } },
        [
          _c("MediaFilePicker", {
            attrs: {
              label: "Изображения",
              "file-type": _vm.$options.mediaTypesByKeys.IMAGE,
              value: _vm.listItem.data.images,
            },
            on: {
              change: function ($event) {
                return _vm.mixChangeListItemHandler($event, "images")
              },
            },
          }),
        ],
        1
      ),
      _c(
        "v-col",
        { attrs: { cols: "12" } },
        [
          _c("MediaFilePicker", {
            attrs: {
              label: "Аудио *",
              multiple: false,
              "file-type": _vm.$options.mediaTypesByKeys.AUDIO,
              value: _vm.listItem.data.audioId,
            },
            on: {
              change: function ($event) {
                return _vm.mixChangeListItemHandler($event, "audioId")
              },
            },
            scopedSlots: _vm._u([
              {
                key: "preview-bottom",
                fn: function () {
                  return [
                    _c("ErrorMessage", {
                      attrs: { message: _vm.errorMessages.audioId },
                    }),
                  ]
                },
                proxy: true,
              },
            ]),
          }),
        ],
        1
      ),
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }